import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, LogIn } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';

const AdminDashboard = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      navigate('/admin/login');
    } else {
      navigate('/admin/products');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center px-4">
      <Card className="w-full max-w-md text-center">
        <CardContent className="py-12">
          <Package className="w-16 h-16 mx-auto text-rose-800 mb-4" />
          <h2 className="text-2xl font-serif text-rose-900 mb-4">Admin Dashboard</h2>
          <p className="text-gray-600 mb-6">Redirecting...</p>
          <Button
            onClick={() => navigate('/admin/login')}
            className="bg-rose-800 hover:bg-rose-900 text-white"
          >
            <LogIn className="w-4 h-4 mr-2" />
            Go to Login
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminDashboard;
